export class MenuItemsModel {
    public label = "";
    public icon  = "";
    public route = "";
    public url = "";
}